<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Geral</span>
                </h4>
                <filtros
                    :responsaveis="responsaveis"
                    :unidades="unidades"
                    :fornecedores="fornecedores"
                    tiposFiltros="tguia"
                    @filtroAtualizado="filtro = $event"
                    @errosValidacao="tratarErrosValidacao"
                ></filtros>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio()"
                    class="ml-2"
                >
                    <span> <i class="fa fa-file-o mr-2"></i> Emitir Excel</span>
                </b-button>
                <b-button
                    variant="primary"
                    @click.stop="exportarRelatorio()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-pdf-o mr-2"></i> Emitir PDF</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Filtros from './Filtros'
import RelatoriosServicos from './RelatoriosServicos'

export default {
    components: {
        Filtros
    },

    data() {
        return {
            responsaveis: null,
            unidades: null,
            fornecedores: null,
            filtro: {
                contrato: null,
                responsavel: null,
                unidade: null,
                fornecedor: null,
                centroCusto: null,
                dataMovimentoDe: null,
                dataMovimentoAte: null,
                dataInicioDe: null,
                dataInicioAte: null,
                dataFimDe: null,
                dataFimAte: null,
                apenasAtivos: false
            },
            errosFiltros: {
                temErros: false,
                erros: {},
                mensagens: []
            }
        }
    },

    methods: {
        tratarErrosValidacao(dadosErros) {
            this.errosFiltros = dadosErros
        },

        mostrarModalErros() {
            this.$swal({
                title: 'Erros de Validação',
                html: `
                    <div style="text-align: left;">
                        <p>Corrija os seguintes erros antes de emitir o relatório:</p>
                        <ul style="margin: 0; padding-left: 20px;">
                            ${this.errosFiltros.mensagens
                                .map((erro) => `<li>${erro}</li>`)
                                .join('')}
                        </ul>
                    </div>
                `,
                icon: 'error',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#d33',
                allowOutsideClick: false,
                allowEscapeKey: true
            })
        },

        obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('ruf').then((response) => {
                if (response) {
                    if (response.success) {
                        this.responsaveis = response.data.Funcionarios
                        this.responsaveis.unshift({
                            codFuncionario: null,
                            codNomeFuncionario: 'TODOS'
                        })
                        this.unidades = response.data.Unidades
                        this.unidades.unshift({
                            codCCusto: null,
                            nomeCCusto: 'TODAS',
                            nomeCodCCusto: 'TODAS'
                        })
                        this.fornecedores = response.data.Fornecedores
                        this.fornecedores.unshift({
                            codFornecedor: null,
                            nome: 'TODOS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        emitirRelatorio() {
            this._processarRelatorio('relatoriogeralxlsx', 'xlsx')
        },

        exportarRelatorio() {
            this._processarRelatorio('relatoriogeralpdf', 'pdf')
        },

        _processarRelatorio(tipoRelatorio, extensao) {
            if (this.errosFiltros.temErros) {
                this.mostrarModalErros()
                return
            }

            this.$store.dispatch('addRequest')
            RelatoriosServicos.emitirRelatorio(tipoRelatorio, this.filtro)
                .then((response) => {
                    this._tratarRespostaRelatorio(response, extensao)
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                })
        },

        _tratarRespostaRelatorio(response, extensao) {
            if (!response) return

            if (response.noContent) {
                this.$toast.warning(
                    response.message,
                    'AVISO',
                    this.$toastConfig.warning
                )
            } else if (response.type === 'application/json') {
                this.$toast.error(
                    `Erro ao ${
                        extensao === 'xlsx' ? 'emitir' : 'exportar'
                    } relatório.`,
                    'ERROR',
                    this.$toastConfig.error
                )
            } else {
                this._fazerDownload(response, extensao)
            }
        },

        _fazerDownload(response, extensao) {
            const dataFormatada = this._obterDataFormatada()
            const nomeArquivo = `Relatorio_geral_contratos_${dataFormatada}.${extensao}`
            this.$download(response, nomeArquivo)
        },

        _obterDataFormatada() {
            const hoje = new Date()
            const ano = hoje.getFullYear().toString()
            const mes = (hoje.getMonth() + 1).toString().padStart(2, '0')
            const dia = hoje.getDate().toString().padStart(2, '0')
            return ano + mes + dia
        }
    },

    mounted() {
        this.obterFiltrosOpcoes()
    },

    watch: {
        filtro() {}
    }
}
</script>
